import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";

const RECRUIT_MENU = [
  { label: "人材一覧", path: "/company/candidates" },
  { label: "プロジェクト", path: "/company/projects" },
  { label: "求人", path: "/company/jobs" },
  { label: "担当者", path: "/company/users" },
  { label: "会社情報", path: "/mypage" },
];

const MANAGEMENT_MENU = [
  { label: "メンバー管理", path: "/company/members" },
  { label: "担当者", path: "/company/users" },
  { label: "会社情報", path: "/mypage" },
  { label: "設定", path: "/company/settings/edit" },
];

const Sidebar = () => {
  const nav = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;

  // リクルートもしくはマネジメント
  const [role, setRole] = useState(null);

  useEffect(() => {
    const root = document.querySelector(".react-app-router");
    const roleFromData = root?.dataset?.companyRole;
    setRole(roleFromData ?? null);
  }, []);

  const menuItems = useMemo(() => {
    return role === "management" ? MANAGEMENT_MENU : RECRUIT_MENU;
  }, [role]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: "70px",
        left: 0,
        display: "flex",
        flexDirection: "column",
        bgcolor: "#FAFAFA",
        width: "200ppx",
        height: "100vh",
        borderRight: "1px solid #000",
        zIndex: 10,
      }}
    >
      <Stack spacing={2} sx={{ pt: "100px", px: "24px", width: "100%" }}>
        {menuItems.map((item) => {
          const isActive =
            currentPath === item.path ||
            currentPath.startsWith(item.path + "/");
          return (
            <Button
              key={item.path}
              variant={isActive ? "contained" : "outlined"}
              onClick={() => nav(item.path)}
              sx={{
                height: "44px",
                borderRadius: 0,
                bgcolor: isActive ? "#292929" : "#fff",
                color: isActive ? "#fff" : "#6D6D6D",
                borderColor: "#000",
                fontSize: "12px",
                px: "32px",
                py: "6px",
                "&:hover": {
                  bgcolor: isActive ? "#000" : "#f0f0f0",
                  borderColor: "#000",
                },
              }}
            >
              {item.label}
            </Button>
          );
        })}
      </Stack>
    </Box>
  );
};

export default Sidebar;
